import React, { Component } from 'react'
import { connect } from 'react-redux'
import OvertimeStarTimeItem from './overtimeStarTimeItem'
import { Button } from 'antd'
class OvertimeStarTimeItemList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      timeOptionsValues: [],
      timeIndex: 0,
    };
  }
  componentWillMount() {
    this.initDetail(this.props.detail);
  }

  componentWillReceiveProps(props) {
    if (props.visible != this.props.visible && props.visible) {
      console.log('props.detail:::::', props.detail);
      this.initDetail(props.detail);
    }
  }

  initDetail = (detail) => {
    let result = [];
    if (detail && detail.length > 0) {
      for (var d of detail) {
        result.push({
          date: d.date,
          start: d.start,
          end: d.end,
          workTimes: d.workTimes,
        })
      }
      this.setState({ timeOptionsValues: result });
      if (this.props.onChange) {
        this.props.onChange(result);
      }
    }
    else {
      this.setState({ timeOptionsValues: [] }, this.addTimeOptionItem);
    }
  }

  dateTimeChange = (time) => {
    let item = this.state.timeOptionsValues[time.index];
    item.date = time.date;
    item.start = time.start;
    item.end = time.end;
    item.workTimes = time.workTimes;
    if (this.props.onChange) {
      this.props.onChange(this.state.timeOptionsValues)
    }
  }

  addTimeOptionItem = () => {
    let resultVal = this.state.timeOptionsValues || [];
    resultVal.push(
      {
        date: '',
        start: '',
        end: '',
        workTimes: '',
      }
    )
    this.setState({ timeOptionsValues: resultVal });
  }

  onDelete = (index) => {
    console.log('delete index-----', index);
    if (this.state.timeOptionsValues.length === 1) {
      return;
    }
    let values = this.state.timeOptionsValues;
    console.log('timeOptionsValues-----', values);
    values.splice(index, 1);
    console.log('timeOptionsValues-----', values);
    this.setState({ timeOptionsValues: values });
  }


  render() {
    const { detail } = this.props;
    return (
      <div>
        {this.state.timeOptionsValues.map((item, inx) => {
          return (
            <OvertimeStarTimeItem
              dateChange={this.dateTimeChange}
              onDelete={this.onDelete}
              key={'OvertimeStarTimeItem' + inx} index={inx}
              value={item}
              itemLength={this.state.timeOptionsValues.length}
              hasError={this.props.hasError}
            />
          );
        })}
        <Button type="primary" ghost icon="plus" size="small" onClick={this.addTimeOptionItem}>添加</Button>
      </div>
    );
  }
}
export default OvertimeStarTimeItemList;



// WEBPACK FOOTER //
// ./src/components/process/formWrapper/overtimeStarTimeItemList.js